import { useState } from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import PaymentsTable from "./PaymentsTable"
import PaymentsForm from "./PaymentsForm"

/**
 * Payments page.
 *
 * Responsibilities (intentionally minimal):
 *  - Own the "which payment is selected" state shared between form and table.
 *  - Lay out the two child components.
 *  - Pass `supabase` down; never touch it directly.
 *
 * All data fetching, mutation, and error handling lives in PaymentsForm and
 * PaymentsTable. This keeps the page shell stable and easy to reason about.
 */
export default function Payments({ supabase }) {
    const [selectedLeaseId, setSelectedLeaseId] = useState(null)
    const [selectedPeriodFrom, setSelectedPeriodFrom] = useState(null)

    const handleSuccess = () => {
        setSelectedLeaseId(null)
        setSelectedPeriodFrom(null)
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Grid container spacing={4}>
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        {selectedLeaseId ? "Modifier un paiement" : "Ajouter un paiement"}
                    </Typography>
                    <PaymentsForm
                        supabase={supabase}
                        selectedLeaseId={selectedLeaseId}
                        selectedPeriodFrom={selectedPeriodFrom}
                        onSuccess={handleSuccess}
                    />
                </Grid>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        Liste des paiements
                    </Typography>
                    <PaymentsTable
                        supabase={supabase}
                        selectedLeaseId={selectedLeaseId}
                        setSelectedLeaseId={setSelectedLeaseId}
                        selectedPeriodFrom={selectedPeriodFrom}
                        setSelectedPeriodFrom={setSelectedPeriodFrom}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}